/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unreachable */
/* eslint-disable default-param-last */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-no-target-blank */
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  Alert,
  Avatar,
  Button,
  Cascader,
  Form,
  Image,
  Input,
  Select,
  Skeleton,
  Tag,
  Tooltip,
  message,
} from "antd";
import { isEmpty, isUndefined } from "lodash";
import React, { useContext, useEffect, useMemo, useState } from "react";
import PhoneInput, { formatPhoneNumber, isValidPhoneNumber } from "react-phone-number-input";
import dayjs from "dayjs";
import styled from "styled-components";

import { SearchOutlined } from "@ant-design/icons";
import { navigate } from "gatsby";
import { useDispatch } from "react-redux";
import { UserContext } from "../../../../amplify/authenticator-provider";
import { DEFAULT_COUNTRY } from "../../../../config";
import { CREATE_LEAD, PULL_LEAD_FROM_CRM } from "../../../../graphql/mutation";
import {
  GET_DATA_SERVICE_CONFIG_LIST,
  GET_LEADS_BY_PHONE,
  GET_LEADS_PHONE_FROM_CRM,
  GET_LEADS_PHONE_FROM_DMS,
  GET_LEAD_SOURCES,
  GET_LEAD_SOURCES_DS,
  GET_LOCATIONS,
  GET_LOCATION_VEHICLE_INVENTORY,
  GET_OPPORTUNITTIES_TYPES,
  GET_OPPORTUNITY_STATUS_NEW,
} from "../../../../graphql/query";
import useLang from "../../../../hooks/useLang";
import { AccessPermissionAction, currencies } from "../../../../library/constants";
import { checkAccessPermission, closeDialog } from "../../../../library/helpers";
import { formatPrice, vehicleFilter } from "../../../../library/utils";
import TextInput from "../../../../library/textInput";
import { CRM_TYPES, CRM_TYPE_LABELS } from "../../../../constants/crmConstants";
import { pinLeadToTop } from "../../../../redux/slices/leadSlice";
import { setLocationIdSlice } from "../../../../redux/slices/locationSlice";
import { LeadStatus, displayPhoneNumbers } from "../engagementHelpers";
import { crmLinkGeneration } from "../opporotunityLayer/crmLinks";
import OpportunityWarning, {
  handleOpportunityDilaog,
} from "../opporotunityLayer/opportuityWarning";
import { WishlistVehicleForm } from "../../vehicleForms";
import {
  OpportunityStatusCascader,
  OpportunityTypeCascader,
} from "../../cascaders/OpportunityCascaders";
import useDepartment from "../../../../hooks/useDepartment";
import VehicleInventoryDetailsDrawer from "../../../inventory/VehicleInventoryDetailsDrawer";

const ModelDiv = styled.div`
  .ant-list-item-action {
    display: flex;
    justify-content: end;
  }
`;

const formatCrmPhone = phone => {
  if (!phone) return "";
  const digits = String(phone).replace(/\D/g, "");
  const e164 = digits.length === 10 ? `+1${digits}` : `+${digits}`;
  return isValidPhoneNumber(e164) ? formatPhoneNumber(e164) : phone;
};

// Label/value row used inside the existing-lead detail card. Label sits left in
// muted grey, value is right-aligned and emphasised — matching the design.
// Collapse every Unicode whitespace variant down to single spaces, then trim.
// `\s` already matches NBSP, narrow/figure spaces, ideographic space and BOM;
// the class also adds a zero-width space. Imported/CRM phone values frequently
// carry a trailing NBSP, which the browser does NOT
// collapse under `white-space: normal` and which `text-align: right` then renders
// as a gap on the right edge - breaking column alignment. Guards every value.
const sanitizeText = value => {
  if (typeof value !== "string") return value;
  return value.replace(/[\s\u200b]+/g, " ").trim();
};

const LeadDetailRow = ({ label, value }) => (
  <div className="flex items-start justify-between gap-3 w-full">
    <span className="text-[13px] font-[400] text-grey-500 flex-shrink-0">{label}</span>
    <div className="flex-1 min-w-0 text-[13px] font-[500] text-grey-800 text-right break-words">
      {sanitizeText(value)}
    </div>
  </div>
);

const getLocation = user => {
  let location = null;
  if (user && user.locations) {
    const locationId = sessionStorage.getItem("currentLocationId")?.includes(",")
      ? user?.locationId
      : sessionStorage.getItem("currentLocationId");
    location = user.locations.find(loc => parseInt(loc.location.id) === parseInt(locationId));
  }
  return location ? location.location : null;
};

/**
 * Resolves the default opportunity type ID based on priority:
 * 1. User's primary department opportunity type
 * 2. Location-level opportunity type
 * 3. null
 */
const resolveDefaultOpportunityType = ({ departments = [], user, location }) => {
  const primaryDept = (user?.userDepartments || []).find(d => d.isPrimary);
  if (primaryDept && departments?.length > 0) {
    const match = departments.find(d => d.name === primaryDept.department?.name);
    if (match?.opportunityType?.id) {
      return match.opportunityType.id;
    }
  }
  return location?.opportunityType?.id || null;
};

const isServiceCrmOpportunityType = value =>
  String(value || "")
    .trim()
    .toLowerCase() === "service";

// When the CRM iframe URL signals an opportunity type (e.g. crmOpportunityType=service),
// resolve it to a leaf opportunityType id by picking the first child under the matching
// parent. Falls back to the parent itself when no children exist.
const resolveServiceOpportunityType = types => {
  if (!Array.isArray(types) || types.length === 0) return null;
  const isService = name =>
    String(name || "")
      .trim()
      .toLowerCase() === "service";
  let serviceParent = types.find(t => isService(t.name) && !t?.parentType?.id);
  if (!serviceParent) {
    const childWithServiceParent = types.find(t => t?.parentType && isService(t.parentType.name));
    if (childWithServiceParent) serviceParent = childWithServiceParent.parentType;
  }
  if (!serviceParent?.id) return null;
  const firstChild = types.find(t => +t?.parentType?.id === +serviceParent.id);
  return firstChild ? +firstChild.id : +serviceParent.id;
};

const AddPhoneModal = props => {
  const {
    phoneNumber,
    // EAI-441 — address from an email-icon click in the CRM. Its PRESENCE (not
    // its value) puts the modal in email-only mode: the email becomes the
    // required field and the phone becomes optional, so a lead can be created
    // with no phone at all. Callers pass `undefined` (never "") when no email
    // was clicked, which keeps every existing phone flow phone-required.
    email = undefined,
    setModalVisible,
    onSetLead,
    variables,
    sources,
    onLeadStatus,
    onLeadOwners,
    onVehicles,
    crmIntegration = "",
    isFromChatbot = false,
    leadFirstName = "",
    leadLastName = "",
    handleLeadCRMName = () => {},
    handleCancelBtn = () => {},
    entityId,
    eventId,
    locationName,
    isFromCRM = false,
    vinCustomerId,
    vinDealerId,
    refetchLeads,
    siteId = "",
    crmSiteId = "",
    crmLeadId = "",
    paramLeadId = "",
    crmOpportunityType = "",
    crmAppointmentId = "",
  } = props;
  const isEmailRequired = !isUndefined(email);
  const [lang] = useLang();
  const { user } = useContext(UserContext);
  const formatedPhone = isUndefined(phoneNumber)
    ? ""
    : phoneNumber.length === 10
    ? `+1${phoneNumber}`
    : phoneNumber.length === 11
    ? `+${phoneNumber}`
    : phoneNumber;
  const dispatch = useDispatch();
  const canchangeLocation = checkAccessPermission(
    AccessPermissionAction.LEAD_MANAGEMENT_SEND_TO_STORE
  );

  const [isOpporDialogFlagChanged, setIsOpprDialogFlagChanged] = useState(false);
  const [userLocationsId, setUserLocationsId] = useState([]);
  const [phone, setPhone] = useState(formatedPhone);
  // Polaris requires a postal code on every lead, so for a Polaris-configured
  // location we require it here (the backend also enforces it on CreateLead).
  const [postalCode, setPostalCode] = useState("");
  const [isPolarisLocation, setIsPolarisLocation] = useState(false);
  const [emailAddress, setEmailAddress] = useState(email || "");
  const [firstName, setFirstName] = useState(leadFirstName || "");
  const [lastName, setLastName] = useState(leadLastName || "");
  const isTekionWithName =
    crmIntegration === CRM_TYPES.TEKION && (!isEmpty(leadFirstName) || !isEmpty(leadLastName));
  // Tekion can open this modal with only a lead/opportunity id — no phone.
  // Everything here is keyed off `phone`, so nothing loads: GET_LEADS_BY_PHONE
  // is skipped, and it's the only caller of getLeadsPhoneFromCRM. This flag
  // fires that CRM lookup directly and opens the render gates below.
  //
  // TODO: remove once Tekion surfaces supply a phone (or the lookup stops
  // being phone-driven) — every `|| isTekionWithoutPhone` below goes with it.
  const isTekionWithoutPhone =
    crmIntegration === CRM_TYPES.TEKION &&
    isEmpty(phone) &&
    (!isEmpty(paramLeadId) || !isEmpty(crmLeadId));
  const [leads, setLeads] = useState([]);
  // GET_LEADS_BY_PHONE runs inside FoundPhoneJSX but the footer actions live here,
  // so the child reports its loading up. Without it the footer renders while the
  // duplicate list is still being fetched (leads is still empty) and
  // "Start conversation" is clickable before we know the lead exists.
  const [duplicateCheckLoading, setDuplicateCheckLoading] = useState(false);
  const [otherData, setotherData] = useState(() => {
    const currentLocationId = sessionStorage.getItem("currentLocationId") || "";
    return currentLocationId.includes(",") ? {} : { location: currentLocationId };
  });
  const [opportunityStatusList, setOpportunityStatusList] = useState([]);
  const [opportunitySource, setopportunitySource] = useState(null);
  const [opportunitySourcePath, setOpportunitySourcePath] = useState([]);
  const [opportunityStatus, setOpportunityStatus] = useState(null);
  const [opportunityType, setOpportunityType] = useState(null);
  const [opportunityTypes, setOpportunityTypes] = useState([]);
  const [opportunityWarningDialog, setOpportunityWarningDialog] = useState(false);
  const [opportunityInfo, setOpportunityInfo] = useState({});
  const [isCrm, setisCrm] = useState(false);
  const [skipduplicate, setskipduplicate] = useState(false);
  const [showWishlistForm, setShowWishlistForm] = useState(false);
  const [wishlistData, setWishlistData] = useState({
    inputType: "wishlist",
    customerInterest: "BUY",
  });
  const [inventoryDetailsDrawerOpen, setInventoryDetailsDrawerOpen] = useState(false);
  const [selectedVehicleForInventoryDetails, setSelectedVehicleForInventoryDetails] =
    useState(null);
  const currentLocation = getLocation(user);
  const selectedLocation = useMemo(
    () => user?.locations?.find(loc => loc.location.id === otherData?.location),
    [user?.locations, otherData?.location]
  );
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  // Settings for quick lead form fields
  const { hasLeadStatusDisplay, hasLeadSourceDisplay } = React.useMemo(() => {
    const parsedSettings = currentLocation?.settings || {};
    return {
      hasLeadStatusDisplay: parsedSettings.QUICK_LEAD_STATUS_ENABLED || false,
      hasLeadSourceDisplay: parsedSettings.QUICK_LEAD_SOURCE_ENABLED || false,
      hasOpportunityTypeDisplay: parsedSettings.QUICK_LEAD_OPPORTUNITY_TYPE_ENABLED || false,
    };
  }, [currentLocation]);

  const hasOpportunityFieldsDisplay =
    selectedLocation?.location?.settings?.QUICK_LEAD_OPPORTUNITY_TYPE_ENABLED;

  // When enabled, shows the "Ignore and Add as new lead" action so a duplicate
  // lead can be created even though a matching lead already exists.
  const hasDuplicateLeadCreation =
    selectedLocation?.location?.settings?.QUICK_LEAD_DUPLICATE_CREATION_ENABLED || false;

  const [createLead, { loading: createLeadLoader }] = useMutation(CREATE_LEAD);
  const [selectedSource, setCampaignSource] = useState([]);

  // Fetch departments for the currently selected location.
  // onCompleted fires when departments load/change — sets oppr type based on dept > location priority.
  const { departments: departmentsList } = useDepartment({
    locationId: otherData?.location,
    queryFetchPolicy: "cache-and-network",
    onCompleted: departments => {
      // CRM context (e.g. Tekion "BDC Scheduling") wins over dept/location defaults
      if (isServiceCrmOpportunityType(crmOpportunityType)) return;
      const resolved = resolveDefaultOpportunityType({
        departments,
        user,
        location: selectedLocation?.location,
      });
      setOpportunityType(resolved ? +resolved : null);
    },
  });

  // Helper function to find default item in nested structure (using reduce to avoid for...of)
  const findDefaultInNested = items => {
    if (!items || !Array.isArray(items)) return null;
    return items.reduce((found, item) => {
      if (found) return found;
      if (item.isDefault) return item;
      if (item.childs && item.childs.length > 0) {
        return findDefaultInNested(item.childs);
      }
      return null;
    }, null);
  };

  // Helper to get location IDs
  const getLocationIds = () => {
    return (sessionStorage?.getItem("currentLocationId") || "").includes(",")
      ? sessionStorage
          ?.getItem("currentLocationId")
          ?.split(",")
          .map(el => +el)
      : [+sessionStorage?.getItem("currentLocationId")];
  };

  // Build complete parent chain for a given type ID (same logic as leadOpportunityInformationForm)
  const getParentChain = (typeId, types) => {
    const chain = [typeId]; // Start with the current type
    const findTypeById = id => types.find(type => +type.id === +id);

    let currentId = typeId;
    while (currentId) {
      const currentType = findTypeById(currentId);
      if (currentType && currentType.parentType && currentType.parentType.id) {
        const parentId = currentType.parentType.id;
        chain.push(parentId);
        currentId = parentId;
      } else {
        break;
      }
    }
    return chain;
  };

  // Get root parent ID for opportunity type (for status fetching)
  const getRootParentTypeId = (typeId, types) => {
    const parentChain = getParentChain(typeId, types);
    // Return the topmost parent (last item in chain)
    return parentChain[parentChain.length - 1];
  };

  // Lazy query for fetching opportunity statuses based on selected type
  const [fetchOpportunityStatusByType, { loading: opportunityStatusByTypeLoader }] = useLazyQuery(
    GET_OPPORTUNITY_STATUS_NEW,
    {
      fetchPolicy: "network-only",
      onCompleted: resp => {
        setOpportunityStatusList(resp.getOpportunityStatusNew || []);
        // Set default status if available (search in nested structure)
        const defaultStatus = findDefaultInNested(resp.getOpportunityStatusNew || []);
        if (defaultStatus) {
          setOpportunityStatus(+defaultStatus.key);
        } else {
          setOpportunityStatus(null);
        }
      },
    }
  );

  // Query for opportunity types - this also triggers status fetch
  const { loading: opportunityTypesLoader } = useQuery(GET_OPPORTUNITTIES_TYPES, {
    variables: {
      industryId: user?.company?.industry?.id || null,
    },
    onCompleted: resp => {
      const types = resp.getOpportunityTypes || [];
      setOpportunityTypes(types);
      // CRM context (e.g. Tekion "BDC Scheduling" with crmOpportunityType=service)
      // selects the Service parent's default (first) child and overrides the
      // dept/location defaults below.
      const serviceId = isServiceCrmOpportunityType(crmOpportunityType)
        ? resolveServiceOpportunityType(types)
        : null;
      // Set initial opportunity type (dept onCompleted may override later with dept-level)
      const resolved = resolveDefaultOpportunityType({
        departments: departmentsList,
        user,
        location: selectedLocation?.location,
      });
      const resolvedId = serviceId || (resolved ? +resolved : null);
      setOpportunityType(resolvedId);
      if (resolvedId) {
        const rootParentTypeId = getRootParentTypeId(resolvedId, types);
        fetchOpportunityStatusByType({
          variables: { locationIds: getLocationIds(), opportunityTypeId: rootParentTypeId },
        });
      } else {
        fetchOpportunityStatusByType({ variables: { locationIds: getLocationIds() } });
      }
    },
  });

  // Keep opportunityStatusLoader for backward compatibility (used in loading state)
  const opportunityStatusLoader = opportunityStatusByTypeLoader;

  const [getLeadsPhoneFromCRM, { loading: crmLoading }] = useLazyQuery(GET_LEADS_PHONE_FROM_CRM, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      setLeads(res?.getLeadsByPhoneFromCrm || []);
      setisCrm(true);
    },
  });
  const [getLeadsPhoneFromDMS, { loading: dmsLoading }] = useLazyQuery(GET_LEADS_PHONE_FROM_DMS, {
    fetchPolicy: "network-only",
    onCompleted: res => {
      setLeads(res?.getLeadsByPhoneFromDms || []);
      setisCrm(true);
    },
  });
  const { data: resp } = useQuery(GET_LOCATIONS, {
    variables: { companyId: user?.company?.id },
  });

  // Detect whether the SELECTED location has an active polaris_service config.
  // dataServiceConfigs aren't carried per-location on the locations list, so we
  // look them up for the chosen location and flag Polaris to require postal code.
  const [fetchDataServiceConfigs] = useLazyQuery(GET_DATA_SERVICE_CONFIG_LIST, {
    fetchPolicy: "network-only",
    onCompleted: data => {
      const configs = data?.getDataServiceConfig?.data || [];
      const hasPolaris = configs.some(
        cfg => cfg?.isActive && cfg?.dataService?.serviceName === "polaris_service"
      );
      setIsPolarisLocation(hasPolaris);
    },
    onError: () => setIsPolarisLocation(false),
  });

  useEffect(() => {
    const selectedLocationId = otherData?.location;
    if (!selectedLocationId || !user?.company?.id) {
      setIsPolarisLocation(false);
      return;
    }
    fetchDataServiceConfigs({
      variables: { companyId: user?.company?.id, locationId: selectedLocationId, pageSize: 100 },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherData?.location, user?.company?.id]);

  const [pullCrmLead, { loading: crmPullLoader }] = useMutation(PULL_LEAD_FROM_CRM);

  // Any in-flight lead lookup: local duplicate check, CRM/DMS search, or CRM pull.
  const isLeadLookupInProgress = duplicateCheckLoading || crmLoading || dmsLoading || crmPullLoader;

  const locIds = (sessionStorage.getItem("currentLocationId") || "").includes(",")
    ? sessionStorage
        .getItem("currentLocationId")
        .split(",")
        .map(el => +el)
    : [+sessionStorage.getItem("currentLocationId")];
  const locationId = sessionStorage.getItem("currentLocationId");

  const { data: vdpData, loading: vdpLoader } = useQuery(GET_LOCATION_VEHICLE_INVENTORY, {
    variables: {
      locationIds: locIds,
      currentLocationId: locationId,
      // search,
    },
  });
  const phoneUpForNissan = [
    {
      id: "7610",
      name: "AutoAlert",
    },
    {
      id: "7223",
      name: "KBB",
    },
    {
      id: "7233",
      name: "Buy Back Mailer",
    },
    {
      id: "7594",
      name: "Capital One",
    },
    {
      id: "7294",
      name: "CarFax",
    },
    {
      id: "7378",
      name: "CarGurus",
    },
    {
      id: "7921",
      name: "Credit Card Mailer",
    },
    {
      id: "5157",
      name: "Drive By/Location",
    },
    {
      id: "7562",
      name: "Google",
    },
    {
      id: "7209",
      name: "Lease Retention",
    },
    {
      id: "8327",
      name: "Nissan List Other",
    },
    {
      id: "7538",
      name: "Nissan USA",
    },
    {
      id: "7388",
      name: "Referral",
    },
    {
      id: "7218",
      name: "Retail Retention",
    },
    {
      id: "7566",
      name: "Service Customer",
    },
    {
      id: "7474",
      name: "ShopEmpireAuto.com",
    },
    {
      id: "7536",
      name: "Website",
    },
  ];

  const phoneUpForToyota = [
    {
      id: "7378",
      name: "CarGurus",
    },
    {
      id: "7294",
      name: "CarFax",
    },
    {
      id: "7740",
      name: "Cars.com",
    },
    {
      id: "7760",
      name: "Edmunds",
    },
    {
      id: "7447",
      name: "AutoAlert",
    },
    {
      id: "7402",
      name: "Dealership Website",
    },
    {
      id: "8197",
      name: "Honda Conquest Mail",
    },
    {
      id: "7209",
      name: "Lease Retention",
    },
    {
      id: "7388",
      name: "Referral",
    },
    {
      id: "7218",
      name: "Retail Retention",
    },
    {
      id: "7475",
      name: "Service Sales",
    },
    {
      id: "7474",
      name: "ShopEmpireAuto.com",
    },
  ];
  const handleSearch = e => {
    setPhone(e);
  };

  const handleLocationChange = value => {
    setotherData(prev => ({ ...prev, location: value }));
    const newLocation = user?.locations?.find(loc => String(loc.location.id) === String(value));
    const serviceId = isServiceCrmOpportunityType(crmOpportunityType)
      ? resolveServiceOpportunityType(opportunityTypes)
      : null;
    const resolved = resolveDefaultOpportunityType({
      departments: [],
      user,
      location: newLocation?.location,
    });
    const resolvedId = serviceId || (resolved ? +resolved : null);
    setOpportunityType(resolvedId);
    if (resolvedId) {
      const rootParentTypeId = getRootParentTypeId(resolvedId, opportunityTypes);
      fetchOpportunityStatusByType({
        variables: { locationIds: [value], opportunityTypeId: rootParentTypeId },
      });
    } else {
      fetchOpportunityStatusByType({ variables: { locationIds: [value] } });
    }
  };

  const handleCancel = () => {
    if (isFromChatbot) {
      handleCancel();
    }
    handleLeadCRMName();
    closeDialog("addLeadViaPhone");
  };
  const handleSave = async e => {
    // The duplicate/CRM lookup is still running. The footer button is disabled for
    // this, but guard the handler too (Enter key / programmatic callers).
    if (isLeadLookupInProgress) return;
    if (e) {
      // Email-only mode inverts which contact field is mandatory: the lead is
      // created off the address alone, so the phone is optional here.
      if (isEmpty(phone) && !isEmailRequired) {
        message.error(lang.enterPhoneNumber);
        return;
      }
      if (isEmpty(emailAddress) && isEmailRequired) {
        message.error(lang.enterEmailAddress);
        return;
      }
      if (isEmpty(firstName)) {
        message.error(lang.enterFirstNameLabel);
        return;
      }
      if (isEmpty(lastName)) {
        message.error(lang.enterLastNameLabel);
        return;
      }

      // Validate Opportunity Type (mandatory only if setting is enabled)
      if (
        hasOpportunityFieldsDisplay &&
        (opportunityType === null || opportunityType === undefined)
      ) {
        message.error("Please select an Opportunity Type");
        return;
      }
      // console.log("Selected Opportunity opportunityStatus ID:", opportunityStatus);
      // Validate Opportunity Source (mandatory)
      if (
        hasLeadSourceDisplay &&
        (opportunitySource === null ||
          opportunitySource === undefined ||
          opportunitySource === "" ||
          opportunitySource === 0)
      ) {
        message.error(lang.enterOpportunitySourceLabel || "Please select an Opportunity Source");
        return;
      }

      // Validate Opportunity Status (mandatory)
      if (hasLeadStatusDisplay && (opportunityStatus === null || opportunityStatus === undefined)) {
        message.error("Please select an Opportunity Status");
        return;
      }

      const defaultSource = sources?.find?.(item => item.name === "SMAI")?.id || 7;
      try {
        if (isEmpty(otherData?.location)) {
          return message.error("Select a location before proceeding");
        }
        // Polaris requires a postal code on every lead; enforce it in the UI for
        // Polaris-configured locations (backend also rejects it otherwise).
        if (isPolarisLocation && isEmpty(postalCode?.trim?.() || "")) {
          return message.error(
            "Postal code is required for this dealership (Polaris integration). Please provide the customer's postal code."
          );
        }
        let payload = {
          firstName: firstName,
          lastName: lastName,
          fullName: `${firstName} ${lastName}`,
          leadSourceType: "MANUAL",
          leadSourceOriginalId: parseInt(selectedSource) || defaultSource,
          opportunitySourceId: opportunitySource,
          opportunityStatusId: opportunityStatus || null,
          opportunityTypeId: opportunityType || null,
          // Filled in below. An email-only lead sends no phones at all, and
          // `isAddPhone` goes with them — it tells the backend the create came
          // from the add-phone flow.
          phones: [],
          primaryOwnerId: user?.id,
          dsEventId: eventId || null,
          dsEntityId: entityId || null,
          locationId: otherData.location,
          ...otherData,
          ...(postalCode?.trim?.() ? { leadAddressObj: { postalCode: postalCode.trim() } } : {}),
          isPushCrm: entityId || isFromCRM ? false : true,
          leadOpportunityUsers: [
            {
              userTypeId: null,
              userId: user?.id,
            },
          ],
          // departmentId: selectedDepartment || null,
        };

        // Read the `phone` STATE, not the `phoneNumber` prop: it carries the
        // E.164 formatting and any manual edit made in the input. Empty in the
        // email-only flow, which is what keeps `phones` off the payload.
        if (phone) {
          payload = {
            ...payload,
            isAddPhone: true,
            phones: [{ phone: phone, phoneType: "Mobile" }],
          };
        }
        if (emailAddress) {
          payload = {
            ...payload,
            // LeadEmailsObj.emailType is a GraphQL enum (PERSONAL / WORK /
            // OTHER) — send the enum NAME, not its "Personal" value.
            emails: [{ email: emailAddress, emailType: "PERSONAL", isPrimary: true }],
          };
        }

        if (vinCustomerId) {
          payload = { ...payload, vsContactId: vinCustomerId };
        }
        if (vinDealerId) {
          payload = { ...payload, vsDealerId: vinDealerId };
        }

        const res = await createLead({
          variables: payload,
        });

        if (res?.data?.createLead?.statusCode === 200) {
          const lead = res?.data?.createLead?.lead || {};
          await refetchLeads();
          onSetLead(lead, "new", "phoneLead");
          setModalVisible(false);
          closeDialog("addLeadViaPhone");
          message.success(res?.data?.createLead.message);
        } else {
          message.error(res?.data?.createLead?.message);
        }
      } catch (err) {
        console.log("Error in createLead", err);
      }
    }
  };

  const pullToSMAI = async (id, locationId, lead, leadPhone) => {
    try {
      const res = await pullCrmLead({
        variables: {
          crmLeadId: id,
          locationId: locationId,
          crmAppointmentId: crmAppointmentId || null,
          oppType: crmOpportunityType ? crmOpportunityType.toUpperCase() : null,
        },
      });
      const pullCrmLeadRes = res?.data?.pullCrmLead;
      const pulledLead = pullCrmLeadRes?.lead;
      if (pullCrmLeadRes?.statusCode === 200 && pulledLead && !isEmpty(pulledLead)) {
        setModalVisible(false);
        closeDialog("addLeadViaPhone");
        onSetLead(
          {
            ...pulledLead,
          },
          "new",
          "phoneLead"
        );
      } else {
        message.error(pullCrmLeadRes?.message || lang.somethingWentWrong || "Something went wrong");
      }
    } catch (error) {
      console.error("pullToSMAI error:", error);
    }
  };

  const onCreateLead = () => {
    if (!canchangeLocation) {
      message.error(lang.viewLeadCurrentLocation);
      return;
    }
    const location = (resp.getLocations || []).find(
      el => +el.id === +sessionStorage.getItem("currentLocationId")
    );
    const MODAL_CONTENT = `${lang.createSameLead} ${
      location?.title
    } ${lang.location.toLowerCase()}`;
  };

  useEffect(() => {
    if (user && user?.locations?.length > 0) {
      const locationIDs = user?.locations.map(location => location?.location?.id);
      setUserLocationsId(locationIDs);
    }
  }, [user]);

  const locationPermission = lead => {
    const lead_opp_locations = lead?.leadOpportunities?.map(opp => opp?.location);
    let userHasLocationPermission = false;
    if (lead_opp_locations?.length > 0 && userLocationsId?.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const loc of lead_opp_locations) {
        if (userLocationsId.includes(loc?.id)) {
          userHasLocationPermission = true;
          break;
        }
      }
    }
    if (userHasLocationPermission) {
      const location = sessionStorage.getItem("currentLocationId");
      const lead_opp_location_ids = lead_opp_locations?.map(loc => loc?.id);
      if (
        +location === +lead?.location?.id ||
        lead_opp_location_ids.includes(+location) ||
        location.includes(",")
      ) {
        dispatch(pinLeadToTop(lead));
      } else {
        const { phone } = lead.phoneNumbers[0];
        const lead_opp_loc_id = lead?.location?.id || lead_opp_locations[0]?.id;
        if (window.location.pathname.includes("browser-ext")) {
          navigate(
            `/browser-ext/${phone.replace("+", "")}?loc=${lead_opp_loc_id}&leadId=${lead.id}`
          );
        } else {
          navigate(
            `/engagements/activity-center/${phone.replace("+", "")}?loc=${lead_opp_loc_id}&leadId=${
              lead.id
            }`
          );
        }
        dispatch(setLocationIdSlice({ locationId: lead_opp_loc_id }));
        sessionStorage.setItem("currentLocationId", lead_opp_loc_id);
        closeDialog("addLeadViaPhone");
      }
      closeDialog("addLeadViaPhone");
    } else {
      message.error(`${lang.leadPermission} ${lead?.location?.title}`);
    }
  };

  const handleOpporDialogFlagChanged = () => {
    setIsOpprDialogFlagChanged(true);
    localStorage.setItem("isOpporDialogFlagChangedLocal", "true");
  };

  const handleOpportunityWarningDialog = (
    item,
    crmLink,
    opprId,
    opprName,
    isOpp = false,
    crmLeadObj
  ) => {
    setOpportunityInfo({
      ...item,
      opprLink: crmLink,
      opprId: opprId,
      opprName: opprName,
      isOpp: isOpp,
      crmLeadObj: crmLeadObj,
    });
    setOpportunityWarningDialog(true);
  };

  const handleOpportunityIdDialog = (oppr, crmLeadObj, lead) => {
    // DS
    if (
      (oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId) ||
      crmLeadObj?.dsExtractedLead?.dsLeadId
    ) {
      const opprId =
        oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId
          ? String(oppr?.dsOpportunityEvents[0]?.dsEventId)
          : crmLeadObj?.dsExtractedLead?.dsLeadId
          ? String(crmLeadObj?.dsExtractedLead?.dsLeadId).padStart(4, "0")
          : oppr?.id;

      let opprName;
      if (
        (oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId) ||
        crmLeadObj?.dsExtractedLead?.dsLeadId
      ) {
        opprName =
          oppr &&
          oppr?.dsOpportunityEvents &&
          oppr?.dsOpportunityEvents.length > 0 &&
          oppr?.dsOpportunityEvents[0]?.dsEventId
            ? `${lang.salesOpportunity} - ${oppr?.name}`
            : oppr?.name;
      }

      const oppLink =
        oppr?.dsOpportunityEvents?.length > 0 &&
        crmLinkGeneration(
          "DS",
          Boolean(oppr?.dsOpportunityEvents[0]?.dsEventId),
          opprId,
          crmLeadObj?.dsExtractedLead?.dsLeadId
        );
      const dsOppType =
        userLocationsId?.length > 0 && userLocationsId.includes(lead?.location?.id) ? (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() =>
              handleOpportunityWarningDialog(oppr, oppLink, opprId, opprName, false, crmLeadObj)
            }
          >
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              {lang.viewDetails}
            </div>
          </div>
        ) : (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() => {
              message.error(`${lang.dontHaveOppr} ${lead?.location?.title}`);
            }}
          >
            <p>{lang.viewDetails}</p>
          </div>
        );
      return dsOppType;
    }

    // SF
    if (
      (oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId) ||
      crmLeadObj?.sfExtractedLead?.sfLeadId
    ) {
      const opprId =
        oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId
          ? String(oppr?.sfLeadOpportunities[0]?.sfOpportunityId)
          : crmLeadObj?.sfExtractedLead?.sfLeadId
          ? String(crmLeadObj?.sfExtractedLead?.sfLeadId)
          : oppr?.id;

      const oppLink =
        oppr?.sfLeadOpportunities?.length > 0 &&
        crmLinkGeneration(
          "SF",
          Boolean(oppr?.sfLeadOpportunities[0]?.sfOpportunityId),
          opprId,
          "",
          "usAutoSales"
        );

      const isOpp =
        oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId
          ? true
          : false;

      let opprName;
      if (
        (oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId) ||
        crmLeadObj?.sfExtractedLead?.sfLeadId
      ) {
        opprName = oppr?.sfLeadOpportunities[0]?.sfOpportunityId
          ? oppr?.name
          : `${lang.leadLabel}: ${lead?.fullName}`; // asdklasjdasdlkaj
      }
      const sfOppType =
        userLocationsId?.length > 0 && userLocationsId.includes(lead?.location?.id) ? (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() =>
              handleOpportunityWarningDialog(oppr, oppLink, opprId, opprName, isOpp, crmLeadObj)
            }
          >
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              {lang.viewDetails}
            </div>
          </div>
        ) : (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() => {
              message.error(
                `${lang.donthavePermission} ${
                  isOpp ? lang.opportunity.toLowerCase() : lang.lead
                } in the ${lead?.location?.title}`
              );
            }}
          >
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              {lang.viewDetails}
            </div>
          </div>
        );

      return sfOppType;
    }

    // VIN
    if (
      (oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId) ||
      crmLeadObj?.vsExtractedLead?.vsContactId
    ) {
      const opprId =
        oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId
          ? String(oppr?.vsLeadOpportunities[0]?.vsContactId)
          : crmLeadObj?.vsExtractedLead?.vsContactId
          ? String(crmLeadObj?.vsExtractedLead?.vsContactId)
          : oppr?.id;

      const oppLink =
        oppr?.vsLeadOpportunities?.length > 0 &&
        crmLinkGeneration(
          "VIN",
          Boolean(oppr?.vsLeadOpportunities[0]?.vsContactId),
          opprId,
          "",
          "VinSolution"
        );

      const isOpp =
        oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId
          ? true
          : false;

      let opprName;
      if (
        (oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId) ||
        crmLeadObj?.vsExtractedLead?.vsContactId
      ) {
        opprName = oppr?.vsLeadOpportunities[0]?.vsContactId
          ? oppr?.name
          : `${lang.leadLabel}: ${lead?.fullName}`;
      }
      const sfOppType =
        userLocationsId?.length > 0 && userLocationsId.includes(lead?.location?.id) ? (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() =>
              handleOpportunityWarningDialog(oppr, oppLink, opprId, opprName, isOpp, crmLeadObj)
            }
          >
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              {lang.viewDetails}
            </div>
          </div>
        ) : (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() => {
              message.error(
                `You do not have permissions to view ${isOpp ? "opportunity" : "lead"} in the ${
                  lead?.location?.title
                }`
              );
            }}
          >
            <p>{lang.viewDetails}</p>
          </div>
        );

      return sfOppType;
    }

    return "";
  };

  const handleOpportunityId = (oppr, crmLeadObj, lead) => {
    // DS
    if (
      (oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId) ||
      crmLeadObj?.dsExtractedLead?.dsLeadId
    ) {
      const opprId =
        oppr?.dsOpportunityEvents?.length > 0 && oppr?.dsOpportunityEvents[0]?.dsEventId
          ? String(oppr?.dsOpportunityEvents[0]?.dsEventId)
          : crmLeadObj?.dsExtractedLead?.dsLeadId
          ? String(crmLeadObj?.dsExtractedLead?.dsLeadId).padStart(4, "0")
          : oppr?.id;

      const oppLink =
        oppr?.dsOpportunityEvents?.length > 0 &&
        crmLinkGeneration(
          "DS",
          Boolean(oppr?.dsOpportunityEvents[0]?.dsEventId),
          opprId,
          crmLeadObj?.dsExtractedLead?.dsLeadId
        );

      const dsOppType =
        userLocationsId?.length > 0 && userLocationsId.includes(lead?.location?.id) ? (
          <a href={oppLink} target="_blank">
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              <p>{lang.viewDetails}</p>
            </div>
          </a>
        ) : (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() => {
              message.error(`${lang.dontHaveOppr} ${lead?.location?.title}`);
            }}
          >
            <p>{lang.viewDetails}</p>
          </div>
        );
      return dsOppType;
    }

    // SF
    if (
      (oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId) ||
      crmLeadObj?.sfExtractedLead?.sfLeadId
    ) {
      const opprId =
        oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId
          ? String(oppr?.sfLeadOpportunities[0]?.sfOpportunityId)
          : crmLeadObj?.sfExtractedLead?.sfLeadId
          ? String(crmLeadObj?.sfExtractedLead?.sfLeadId)
          : oppr?.id;

      const oppLink =
        oppr?.sfLeadOpportunities?.length > 0 &&
        crmLinkGeneration(
          "SF",
          Boolean(oppr?.sfLeadOpportunities[0]?.sfOpportunityId),
          opprId,
          "",
          "usAutoSales"
        );

      const isOpp =
        oppr?.sfLeadOpportunities?.length > 0 && oppr?.sfLeadOpportunities[0]?.sfOpportunityId
          ? true
          : false;

      const sfOppType =
        userLocationsId?.length > 0 && userLocationsId.includes(lead?.location?.id) ? (
          <a href={oppLink} target="_blank">
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              <p>{lang.viewDetails}</p>
            </div>
          </a>
        ) : (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() => {
              message.error(
                `You do not have permissions to view ${isOpp ? "opportunity" : "lead"} in the ${
                  lead?.location?.title
                }`
              );
            }}
          >
            <p>{lang.viewDetails}</p>
          </div>
        );

      return sfOppType;
    }

    // VIN
    if (
      (oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId) ||
      crmLeadObj?.vsExtractedLead?.vsContactId
    ) {
      const opprId =
        oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId
          ? String(oppr?.vsLeadOpportunities[0]?.vsContactId)
          : crmLeadObj?.vsExtractedLead?.vsContactId
          ? String(crmLeadObj?.vsExtractedLead?.vsContactId)
          : oppr?.id;

      const oppLink =
        oppr?.vsLeadOpportunities?.length > 0 &&
        crmLinkGeneration(
          "VIN",
          Boolean(oppr?.vsLeadOpportunities[0]?.vsContactId),
          opprId,
          "",
          "VinSolution"
        );

      const isOpp =
        oppr?.vsLeadOpportunities?.length > 0 && oppr?.vsLeadOpportunities[0]?.vsContactId
          ? true
          : false;

      const sfOppType =
        userLocationsId?.length > 0 && userLocationsId.includes(lead?.location?.id) ? (
          <a href={oppLink} target="_blank">
            <div className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme">
              <p>{lang.viewDetails}</p>
            </div>
          </a>
        ) : (
          <div
            className="font-sans text-[16px] font-medium block shadow-none secondaryColorTheme"
            onClick={() => {
              message.error(
                `You do not have permissions to view ${isOpp ? "opportunity" : "lead"} in the ${
                  lead?.location?.title
                }`
              );
            }}
          >
            <p>{lang.viewDetails}</p>
          </div>
        );

      return sfOppType;
    }

    return "";
  };

  const { data: sourcesData } = useQuery(GET_LEAD_SOURCES);

  const [getDssources, { data: dsSources, loading: getLeadSourcesLoader }] = useLazyQuery(
    GET_LEAD_SOURCES_DS,
    {
      onCompleted: res => {
        // setCampaignSource();
      },
    }
    // {
    //   variables: {
    //     companyId: user?.company?.id,
    //   },
    // }
  );

  useEffect(() => {
    if (user.company.crmIntegrationType === "DS") {
      getDssources({
        variables: {
          companyId: user?.company?.id,
        },
      });
    }
  }, [user.company.crmIntegrationType]);

  useEffect(() => {
    setCampaignSource("7");
  }, []);

  const renderDepartment = React.useMemo(() => {
    return (
      selectedLocation?.location?.settings?.SHOULD_SHOW_DEPARTMENT_FIELD_IN_LEAD_AND_OPPORTUNITY ||
      false
    );
  }, [selectedLocation]);

  // Fetch departments
  const { departments, fetching: departmentsFetching } = useDepartment({
    locationId: +otherData?.location,
    customSkipCondition: !renderDepartment || !otherData?.location,
  });

  const [form] = Form.useForm();
  // Hoisted so the JSX gate below stays a single line — adding a term inline
  // would overflow 100 chars and reindent the whole button block.
  const showCreateActions = !isEmpty(phone) || isEmailRequired || isTekionWithName;

  return (
    <>
      <ModelDiv>
        {/* Negative horizontal margins span the separator edge-to-edge under the
            modal body's 24px (px-6) padding; pt adds breathing room at the top. */}
        <div className="-mx-6 px-6 pt-2 pb-4 mb-5 border-0 border-b border-solid border-grey-200">
          <h2 className="text-[18px] font-[600] text-grey-800 m-0 leading-tight">Add new lead</h2>
          <p className="text-[13px] font-[400] text-grey-500 mt-1 mb-0">
            {isEmailRequired
              ? "Enter an email address to get started"
              : "Enter a phone number to get started"}
          </p>
        </div>
        <PhoneInputJsx lang={lang} phone={phone} handleSearch={handleSearch} />
        {isEmailRequired && (
          <div className="w-full mt-3">
            <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
              {lang.emailLabel}
              <span className="requireFieldStar ml-0.5">*</span>
            </p>
            <TextInput
              placeholder="example@example.com"
              className="h-10 w-full"
              name="emailAddress"
              value={emailAddress}
              onChange={e => setEmailAddress(e.target.value)}
            />
          </div>
        )}
        {isEmpty(phone) &&
          !isEmailRequired &&
          !isTekionWithName &&
          !isTekionWithoutPhone &&
          isEmpty(crmAppointmentId) && (
            <div className="flex flex-col items-center justify-center text-center py-8">
              <div className="w-12 h-12 rounded-full bg-grey-100 flex items-center justify-center mb-3">
                <SearchOutlined className="text-[20px] text-grey-400" />
              </div>
              <p className="text-[15px] font-[500] text-grey-700 m-0">
                Duplicate check happens automatically
              </p>
              <p className="text-[13px] font-[400] text-grey-400 mt-1 mb-0 max-w-[280px]">
                We&apos;ll make sure this lead doesn&apos;t already exist before creating a new one
              </p>
            </div>
          )}
        {(!isEmpty(phone) ||
          isEmailRequired ||
          isTekionWithName ||
          isTekionWithoutPhone ||
          !isEmpty(crmAppointmentId)) && (
          <FoundPhoneJSX
            isTekionWithName={isTekionWithName}
            emailAddress={emailAddress}
            isEmailRequired={isEmailRequired}
            isTekionWithoutPhone={isTekionWithoutPhone}
            siteId={siteId}
            crmSiteId={crmSiteId}
            crmLeadId={crmLeadId}
            paramLeadId={paramLeadId}
            crmAppointmentId={crmAppointmentId}
            crmOpportunityType={crmOpportunityType}
            leads={leads}
            phone={phone}
            isPolarisLocation={isPolarisLocation}
            postalCode={postalCode}
            setPostalCode={setPostalCode}
            skipduplicate={skipduplicate}
            isCrm={isCrm}
            lang={lang}
            variables={variables}
            crmLoading={crmLoading}
            crmPullLoader={crmPullLoader}
            dmsLoading={dmsLoading}
            onDuplicateCheckLoadingChange={setDuplicateCheckLoading}
            dmsLocationId={currentLocation?.id}
            crmIntegration={crmIntegration}
            handleOpportunityId={handleOpportunityId}
            user={user}
            setopportunitySource={setopportunitySource}
            setOpportunitySourcePath={setOpportunitySourcePath}
            handleOpportunityIdDialog={handleOpportunityIdDialog}
            onCreateLead={onCreateLead}
            locationPermission={locationPermission}
            onLeadStatus={onLeadStatus}
            pullToSMAI={pullToSMAI}
            onLeadOwners={onLeadOwners}
            onVehicles={onVehicles}
            isFromCRM={isFromCRM}
            locationName={locationName}
            firstName={firstName}
            setFirstName={setFirstName}
            lastName={lastName}
            setLastName={setLastName}
            otherData={otherData}
            setotherData={setotherData}
            locationId={locationId}
            vdpData={vdpData}
            vdpLoader={vdpLoader}
            setLeads={setLeads}
            setisCrm={setisCrm}
            getLeadsPhoneFromCRM={payload => {
              if (currentLocation?.dmsIntegration?.dmsType === "ZiiDMS") {
                getLeadsPhoneFromDMS({
                  variables: { phone: payload.variables.phone, locationId: currentLocation?.id },
                });
              } else {
                getLeadsPhoneFromCRM(payload);
              }
            }}
            showWishlistForm={showWishlistForm}
            setShowWishlistForm={setShowWishlistForm}
            wishlistData={wishlistData}
            setWishlistData={setWishlistData}
            leadStatusList={opportunityStatusList}
            opportunityStatusLoader={opportunityStatusLoader}
            setOpportunityStatus={setOpportunityStatus}
            opportunityStatus={opportunityStatus}
            opportunityType={opportunityType}
            setOpportunityType={setOpportunityType}
            opportunityTypes={opportunityTypes}
            opportunityTypesLoader={opportunityTypesLoader}
            fetchOpportunityStatusByType={fetchOpportunityStatusByType}
            getRootParentTypeId={getRootParentTypeId}
            isSourceSelectable={hasLeadSourceDisplay}
            isStatusSelectable={hasLeadStatusDisplay}
            renderDepartment={renderDepartment}
            departments={departments}
            departmentsFetching={departmentsFetching}
            selectedDepartment={selectedDepartment}
            setSelectedDepartment={setSelectedDepartment}
            selectedLocation={selectedLocation}
            isOpportunityTypeSelectable={hasOpportunityFieldsDisplay}
            onLocationChange={handleLocationChange}
            opportunitySource={opportunitySource}
            opportunitySourcePath={opportunitySourcePath}
            inventoryDetailsDrawerOpen={inventoryDetailsDrawerOpen}
            setInventoryDetailsDrawerOpen={setInventoryDetailsDrawerOpen}
            selectedVehicleForInventoryDetails={selectedVehicleForInventoryDetails}
            setSelectedVehicleForInventoryDetails={setSelectedVehicleForInventoryDetails}
          />
        )}

        {/* <ChangeStatusModal data={misc} setdata={setmisc} api /> */}
      </ModelDiv>
      {/* Vehicle Inventory Details Drawer */}
      <VehicleInventoryDetailsDrawer
        open={inventoryDetailsDrawerOpen}
        onClose={() => {
          setInventoryDetailsDrawerOpen(false);
          setSelectedVehicleForInventoryDetails(null);
        }}
        vehicleData={selectedVehicleForInventoryDetails}
      />
      {opportunityWarningDialog && (
        <OpportunityWarning
          opportunityInfo={opportunityInfo}
          crmIntegrationType={crmIntegration}
          crmLeadObj={opportunityInfo?.crmLeadObj}
          visibleModal={opportunityWarningDialog}
          handleOKBtn={() => setOpportunityWarningDialog(false)}
          setModalVisible={() => setOpportunityWarningDialog(false)}
          handleOpporDialogFlagChanged={handleOpporDialogFlagChanged}
        />
      )}

      <div className="mt-5">
        {(leads.length <= 0 || skipduplicate) && showCreateActions && (
          <div className="flex flex-row gap-3">
            <Button
              onClick={isFromChatbot ? handleCancelBtn : handleCancel}
              className="flex-1 h-[40px] rounded-lg font-[500]"
            >
              {lang.cancel}
            </Button>
            <Button
              onClick={handleSave}
              type="primary"
              className="flex-1 h-[40px] rounded-lg font-[500]"
              loading={createLeadLoader}
              disabled={isLeadLookupInProgress}
            >
              Start conversation
            </Button>
          </div>
        )}

        {/* Tekion has no phone to check the length of — without this the
            CRM-resolved lead never renders. */}
        {((phone && phone.length > 3) ||
          (isEmailRequired && !isEmpty(emailAddress)) ||
          isTekionWithoutPhone) &&
          leads.length > 0 &&
          !skipduplicate && (
            <div className="flex flex-row gap-3 items-start">
              {hasDuplicateLeadCreation && (
                <Button
                  key="skip"
                  onClick={() => setskipduplicate(!skipduplicate)}
                  className="flex-1 h-[40px] rounded-lg font-[500]"
                >
                  Ignore and Add as new lead
                </Button>
              )}
              {isCrm && leads.length === 1 ? (
                <div className="flex-1 flex flex-col">
                  <Button
                    type="primary"
                    loading={crmPullLoader}
                    onClick={() => {
                      pullToSMAI(
                        leads[0]?.leadId,
                        leads[0]?.locationId ?? currentLocation?.id,
                        leads[0],
                        leads[0]?.mobile
                      );
                    }}
                    className="w-full h-[40px] rounded-lg font-[500]"
                  >
                    {lang.startConversation}
                  </Button>
                  <p className="text-center text-[12px] text-grey-400 mt-2 mb-0">
                    This will not create a new lead
                  </p>
                </div>
              ) : (
                <Button
                  onClick={isFromChatbot ? handleCancelBtn : handleCancel}
                  className="flex-1 h-[40px] rounded-lg font-[500]"
                >
                  {lang.cancel}
                </Button>
              )}
            </div>
          )}
      </div>
      <style jsx>{`
        .phoneInput .PhoneInput {
          display: flex;
          align-items: stretch;
          gap: 8px;
        }
        .phoneInput .PhoneInputCountry {
          margin: 0;
          padding: 0 12px;
          border: 1px solid #d9d9d9;
          border-radius: 8px;
          background: #ffffff;
          min-width: 64px;
        }
        .phoneInput .PhoneInputInput {
          flex: 1 1 auto;
          width: 100%;
          height: 42px;
          border: 1px solid #d9d9d9;
          border-radius: 8px;
          padding: 6px 14px;
          font-size: 15px;
          outline: none;
        }
        .phoneInput .PhoneInputInput:focus {
          border-color: #3b82f6;
          box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
        }
      `}</style>
    </>
  );
};

export default AddPhoneModal;

function FoundPhoneJSX({
  leads,
  phone,
  emailAddress,
  isEmailRequired,
  skipduplicate,
  isCrm,
  lang,
  crmLoading,
  crmPullLoader,
  dmsLoading,
  onDuplicateCheckLoadingChange,
  dmsLocationId,
  isPolarisLocation,
  postalCode,
  setPostalCode,
  crmIntegration,
  handleOpportunityId,
  user,
  handleOpportunityIdDialog,
  setopportunitySource,
  setOpportunitySourcePath,
  setOpportunityStatus,
  locationPermission,
  opportunityStatus,
  pullToSMAI,
  onLeadOwners,
  onVehicles,
  isFromCRM,
  locationName,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  otherData,
  setotherData,
  locationId,
  vdpData,
  vdpLoader,
  setLeads,
  setisCrm,
  getLeadsPhoneFromCRM,
  showWishlistForm,
  setShowWishlistForm,
  wishlistData,
  setWishlistData,
  leadStatusList,
  opportunityStatusLoader,
  opportunityType,
  setOpportunityType,
  opportunityTypes,
  opportunityTypesLoader,
  fetchOpportunityStatusByType,
  getRootParentTypeId,
  isSourceSelectable,
  isStatusSelectable,
  renderDepartment,
  departments,
  departmentsFetching,
  selectedDepartment,
  setSelectedDepartment,
  selectedLocation,
  isOpportunityTypeSelectable,
  onLocationChange,
  opportunitySource,
  opportunitySourcePath,
  inventoryDetailsDrawerOpen,
  setInventoryDetailsDrawerOpen,
  selectedVehicleForInventoryDetails,
  setSelectedVehicleForInventoryDetails,
  isTekionWithName,
  siteId,
  crmSiteId,
  crmLeadId,
  paramLeadId,
  crmAppointmentId,
  crmOpportunityType,
  isTekionWithoutPhone = false,
}) {
  const { loading } = useQuery(GET_LEADS_BY_PHONE, {
    fetchPolicy: "network-only",
    // Email-only leads have no phone to check, so run the duplicate check off
    // the address instead — getLeadsSearch takes an `email` argument and the
    // backend filters LeadEmails on it. Without this an email-icon click for a
    // customer who already exists would silently create a SECOND lead.
    skip: isEmpty(phone) && isEmpty(emailAddress),
    variables: {
      pageSize: 5,
      page: 1,
      phone: phone || undefined,
      email: isEmpty(phone) ? emailAddress || undefined : undefined,
      // Scope the phone pre-check by CRM context so it doesn't match a
      // same-phone lead in another integration/dealer/site (esp. Tekion).
      crmIntegrationType: crmIntegration || undefined,
      crmDealerId: siteId || undefined,
      crmSiteId: crmSiteId || undefined,
      crmLeadId: crmLeadId || undefined,
      crmOpportunityId: paramLeadId || undefined,
    },
    onCompleted: resp => {
      if (resp?.getLeadsSearch?.data.length > 0) {
        setisCrm(false);
        setLeads(resp?.getLeadsSearch?.data || []);
      } else if (!isEmpty(phone)) {
        // getLeadsByPhoneFromCrm takes a REQUIRED phone and has no email
        // argument, so there's no CRM-side lookup to fall back to for an
        // email-only click — calling it would just fail the operation.
        // Resolving an unpulled CRM customer by email needs an API change.
        getLeadsPhoneFromCRM({
          variables: {
            phone: phone,
            crmIntegrationType: crmIntegration,
            crmDealerId: siteId || "",
            crmSiteId: crmSiteId || undefined,
            crmOpportunityId: paramLeadId || "",
            crmLeadId: crmLeadId || "",
            crmAppointmentId: crmAppointmentId || "",
            oppType: crmOpportunityType ? crmOpportunityType.toUpperCase() : null,
          },
        });
      }
    },
  });

  // The footer's "Start conversation" lives in the parent, so report this
  // lookup's loading upward — it must stay disabled until the duplicate list
  // (and the CRM fallback it chains into) has resolved.
  useEffect(() => {
    onDuplicateCheckLoadingChange?.(loading);
    return () => onDuplicateCheckLoadingChange?.(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  // Phone-less Tekion surfaces: the appointments list gives only a
  // crmAppointmentId, and a lead/opportunity gives only its ids. Either way
  // GET_LEADS_BY_PHONE is skipped, so call the CRM resolver directly.
  useEffect(() => {
    if (!isEmpty(phone)) return;
    if (!crmAppointmentId && !isTekionWithoutPhone) return;
    getLeadsPhoneFromCRM({
      variables: {
        phone: "",
        crmIntegrationType: crmIntegration,
        crmDealerId: siteId || "",
        crmSiteId: crmSiteId || undefined,
        crmOpportunityId: paramLeadId || "",
        crmLeadId: crmLeadId || "",
        crmAppointmentId,
        oppType: crmOpportunityType ? crmOpportunityType.toUpperCase() : null,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    phone,
    crmAppointmentId,
    isTekionWithoutPhone,
    crmIntegration,
    siteId,
    crmLeadId,
    paramLeadId,
    crmOpportunityType,
  ]);

  // Helper function to find default source in nested structure (using reduce to avoid for...of)
  const findDefaultSource = (items, path = []) => {
    if (!items || !Array.isArray(items)) return null;
    return items.reduce((found, item) => {
      if (found) return found;
      const currentPath = [...path, +item.key];
      if (item.isDefault) return { ...item, path: currentPath };
      if (item.childs && item.childs.length > 0) {
        return findDefaultSource(item.childs, currentPath);
      }
      return null;
    }, null);
  };

  // GET_LEAD_SOURCES_DS returns nested children under `parents` at the root level
  // and under `childs` on deeper levels. Normalize to a single `childs` key so the
  // Cascader can render the full parent/child hierarchy.
  const normalizeSources = items => {
    if (!items || !Array.isArray(items)) return [];
    return items.map(item => {
      const nested = item.parents || item.childs || [];
      return {
        key: item.key,
        name: item.name,
        companyLeadSourceId: item.companyLeadSourceId,
        consentOption: item.consentOption,
        childs: normalizeSources(nested),
      };
    });
  };

  const { data: opportunitySources, loading: leadSourcesLoader } = useQuery(GET_LEAD_SOURCES_DS, {
    fetchPolicy: "network-only",
    skip: !otherData?.location,
    variables: {
      companyId: user.company.id,
      locationIds: otherData?.location ? [+otherData.location] : [],
    },
    onCompleted: res => {
      // DS schema has no isDefault flag — this will no-op unless that changes server-side
      const defaultSource = findDefaultSource(normalizeSources(res.getLeadSources || []));
      if (defaultSource) {
        setopportunitySource(+defaultSource.key);
        setOpportunitySourcePath(defaultSource.path || [+defaultSource.key]);
      } else {
        setopportunitySource(null);
        setOpportunitySourcePath([]);
      }
    },
  });

  // Hoisted for the same reason as the parent's showCreateActions.
  const showCreateForm = !isEmpty(phone) || isEmailRequired || isTekionWithName;

  const opportunitySourceOptions = useMemo(
    () => normalizeSources(opportunitySources?.getLeadSources || []),
    [opportunitySources]
  );

  return (
    <>
      {leads.length > 0 &&
        (!isEmpty(phone) ||
          isEmailRequired ||
          (isCrm && (!!crmAppointmentId || isTekionWithoutPhone))) &&
        !skipduplicate &&
        !crmLoading && (
          <Alert
            className="mt-4 rounded-lg border-brand-100 bg-brand-50"
            type="info"
            showIcon
            message={
              <div className="leading-snug">
                <div className="text-[13px] font-[600] text-grey-800">This lead already exists</div>
                <div className="text-[12px] font-[400] text-grey-600">
                  Would you like to continue with the existing record instead?
                </div>
              </div>
            }
          />
        )}
      {loading || crmLoading || crmPullLoader || dmsLoading ? (
        <div className="mt-5">
          <Skeleton
            active
            title={{ width: "55%" }}
            paragraph={{ rows: 4, width: ["100%", "100%", "100%", "100%"] }}
            loading={loading || crmLoading || crmPullLoader || dmsLoading}
          />
        </div>
      ) : (
        <>
          {" "}
          {leads.length > 0 &&
            (!isEmpty(phone) ||
              isEmailRequired ||
              (isCrm && (!!crmAppointmentId || isTekionWithoutPhone))) &&
            !skipduplicate && (
              <div className="w-full mt-4 flex flex-col gap-3">
                {leads.map((item, idx) => {
                  const links = [];
                  crmIntegration?.length > 0 &&
                    links.push(
                      localStorage.getItem("isOpporDialogFlagChangedLocal")
                        ? handleOpportunityId(
                            item?.crmLeadObj?.activeLeadOpportunity,
                            item?.crmLeadObj,
                            item
                          )
                        : !handleOpportunityDilaog(user?.locations, user)
                        ? handleOpportunityId(
                            item?.crmLeadObj?.activeLeadOpportunity,
                            item?.crmLeadObj,
                            item
                          )
                        : handleOpportunityIdDialog(
                            item?.crmLeadObj?.activeLeadOpportunity,
                            item?.crmLeadObj,
                            item
                          )
                    );

                  const email = item?.emails ? item?.emails[0]?.email || "" : "";
                  const leadStatus = item?.crmLeadObj?.activeLeadOpportunity?.opportunityStatus
                    ?.parentStatus
                    ? `${
                        item?.crmLeadObj?.activeLeadOpportunity?.opportunityStatus?.parentStatus
                          ?.name
                      } / ${
                        item?.crmLeadObj?.activeLeadOpportunity?.opportunityStatus?.name || ""
                      }`.replace(/_/g, " ")
                    : item?.crmLeadObj?.activeLeadOpportunity?.opportunityStatus?.name || "";
                  const name = !isCrm
                    ? item?.fullName || ""
                    : `${item?.firstName || ""} ${item?.lastName || ""}`.trim();
                  const initial = (name || "X").substring(0, 1).toUpperCase();
                  const crmLabel = isCrm
                    ? CRM_TYPE_LABELS[crmIntegration] || crmIntegration || ""
                    : "";
                  const validLinks = (links || []).filter(Boolean);
                  // Render owners as right-aligned "First Last (UserType)" lines to match
                  // the design. The shared onLeadOwners helper renders tag chips with a
                  // label/value split that breaks the card alignment, and it appends the
                  // company-role/location qualifier — which should not be shown here.
                  const ownerNodes = (item?.leadUsers || [])
                    .map((lu, i) => {
                      const ownerName = `${lu?.user?.firstName || ""} ${
                        lu?.user?.lastName || ""
                      }`.trim();
                      const role = lu?.userType?.name;
                      const text = [ownerName, role ? `(${role})` : ""].filter(Boolean).join(" ");
                      return text ? <div key={i}>{text}</div> : null;
                    })
                    .filter(Boolean);
                  return (
                    <div key={idx} className="border border-grey-200 rounded-xl p-4">
                      <div className="flex items-center justify-between gap-2">
                        <div className="flex items-center gap-3 min-w-0">
                          <Avatar
                            size={40}
                            className="bg-success-100 text-success-600 font-[600] flex-shrink-0"
                          >
                            {initial}
                          </Avatar>
                          <div className="min-w-0">
                            <div
                              onClick={() => {
                                if (!isCrm) locationPermission(item);
                              }}
                              className={`text-[15px] font-[600] text-grey-800 truncate ${
                                !isCrm ? "cursor-pointer hover:text-brand-500" : ""
                              }`}
                            >
                              {name}
                            </div>
                            {leadStatus ? (
                              <Tooltip placement="topLeft" title={leadStatus}>
                                <span className="text-[13px] font-[500] text-brand-500">
                                  {leadStatus}
                                </span>
                              </Tooltip>
                            ) : null}
                          </div>
                        </div>
                        {crmLabel ? (
                          <Tag className="m-0 rounded-md border-brand-100 bg-brand-50 text-brand-600 font-[500]">
                            {crmLabel}
                          </Tag>
                        ) : null}
                      </div>

                      <div className="border-t border-grey-100 my-3" />

                      <div className="flex flex-col gap-2.5">
                        <LeadDetailRow
                          label={lang.phoneNumbers}
                          value={
                            (!isCrm
                              ? displayPhoneNumbers(item?.phoneNumbers || [])
                              : formatCrmPhone(item.mobile)) || "N/A"
                          }
                        />
                        <LeadDetailRow
                          label={lang.emailLabel}
                          value={!isCrm ? (email === "" ? "N/A" : email) : item.email || "N/A"}
                        />
                        <LeadDetailRow
                          label={lang.source}
                          value={!isCrm ? item?.leadSource?.name || "N/A" : item.source || "N/A"}
                        />
                        <LeadDetailRow
                          label={lang.status}
                          value={
                            (isCrm
                              ? item?.status && LeadStatus(user, item?.status)
                              : item.status && LeadStatus(user, item.status)) || "N/A"
                          }
                        />
                        {(item?.leadUsers || []).length > 0 && !isCrm ? (
                          <LeadDetailRow
                            label={lang.owners}
                            value={
                              ownerNodes.length > 0 ? (
                                <div className="flex flex-col gap-0.5 items-end">{ownerNodes}</div>
                              ) : (
                                "N/A"
                              )
                            }
                          />
                        ) : (
                          <LeadDetailRow
                            label={lang.owner}
                            value={item.owner && item.owner !== "" ? item.owner : "N/A"}
                          />
                        )}
                        <LeadDetailRow
                          label={lang.location}
                          value={
                            !isCrm
                              ? `${item?.location?.title || ""} (${
                                  item?.location?.locationType || lang.store
                                })`
                              : item.location ||
                                user?.locations?.find(l => +l?.location?.id === +item?.locationId)
                                  ?.location?.title ||
                                ""
                          }
                        />
                        {(item?.vehicleOfInterest || []).length > 0 && !isCrm && (
                          <LeadDetailRow
                            label={lang.vehicles}
                            value={onVehicles(item?.vehicleOfInterest || [])}
                          />
                        )}
                        {isCrm &&
                          (item?.appointmentId ||
                            item?.appointmentNumber ||
                            item?.appointmentDatetime) && (
                            <LeadDetailRow
                              label="Appointment"
                              value={[
                                item?.appointmentNumber && `#${item.appointmentNumber}`,
                                item?.appointmentType,
                                item?.appointmentDatetime &&
                                  dayjs(item.appointmentDatetime).format("MM/DD/YYYY hh:mm A"),
                                item?.appointmentStatus,
                              ]
                                .filter(Boolean)
                                .join(" • ")}
                            />
                          )}
                        {isCrm &&
                          (item?.vehicleYear ||
                            item?.vehicleMake ||
                            item?.vehicleModel ||
                            item?.vehicleVin) && (
                            <LeadDetailRow
                              label="Vehicle"
                              value={[
                                [item?.vehicleYear, item?.vehicleMake, item?.vehicleModel]
                                  .filter(Boolean)
                                  .join(" "),
                                item?.vehicleVin && `VIN: ${item.vehicleVin}`,
                              ]
                                .filter(Boolean)
                                .join(" • ")}
                            />
                          )}
                      </div>

                      {/* Per-card "Start conversation" for CRM leads. The modal footer
                          owns this action for the common single-lead phone search; render
                          it here for the cases the footer cannot cover (multiple leads, or
                          the appointment-only flow where phone is empty).
                          Condition must mirror the footer's gate — Tekion-without-phone
                          also renders there now, and both showed at once. */}
                      {isCrm &&
                        !(
                          ((phone && phone.length > 3) || isTekionWithoutPhone) &&
                          leads.length === 1
                        ) && (
                          <Button
                            type="primary"
                            loading={crmPullLoader}
                            onClick={() => {
                              pullToSMAI(
                                item?.leadId,
                                item?.locationId ?? dmsLocationId,
                                item,
                                item.mobile
                              );
                            }}
                            className="mt-3 w-full h-[38px] rounded-lg font-[500]"
                          >
                            {lang.startConversation}
                          </Button>
                        )}

                      {validLinks.length > 0 && (
                        <div className="mt-3 flex justify-end secondaryColorTheme">
                          {validLinks}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          {(leads.length <= 0 || skipduplicate) && showCreateForm && (
            <>
              {leads.length <= 0 && !skipduplicate && (
                <Alert
                  className="mt-4 rounded-lg border-success-100 bg-success-50"
                  message="No existing lead found - you're clear to create a new one."
                  type="success"
                  showIcon
                />
              )}
              {!isFromCRM && !isEmpty(locationName) && (
                <Alert
                  className="mt-3 mb-1 rounded-lg"
                  message={
                    <>
                      This lead will be created in <b>{locationName}</b>
                    </>
                  }
                  type="info"
                  showIcon
                />
              )}
              <div className="grid grid-cols-2 gap-3 mt-4">
                <div className="w-full">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    {lang.firstName}
                    <span className="requireFieldStar ml-0.5">*</span>
                  </p>
                  <TextInput
                    placeholder={lang.firstName}
                    name="firstName"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                  />
                </div>
                <div className="w-full">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    {lang.lastName}
                    <span className="requireFieldStar ml-0.5">*</span>
                  </p>
                  <TextInput
                    placeholder={lang.lastName}
                    name="lastName"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                  />
                </div>
              </div>
              {/* <Form.Item
                  name="lastName"
                  label="Last Name"
                  rules={[{ required: true, message: "Last name is required" }]}
                >
                  <Input placeholder={lang.lastName} name="lastName" />
                </Form.Item> */}
              <div className="w-full mt-3">
                <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                  Location
                  <span className="requireFieldStar">*</span>
                </p>
                <Select
                  className="w-full"
                  name="location"
                  value={otherData.location}
                  placeholder="Select a location"
                  onChange={onLocationChange}
                >
                  {user?.locations?.map((item, index) => (
                    <Select.Option key={index} value={item?.location?.id}>
                      {item?.location?.title}
                    </Select.Option>
                  ))}
                </Select>
              </div>

              {isPolarisLocation && (
                <div className="w-full mt-3">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    Postal Code
                    <span className="requireFieldStar ml-0.5">*</span>
                  </p>
                  <TextInput
                    placeholder="Postal Code"
                    name="postalCode"
                    value={postalCode}
                    onChange={e => setPostalCode(e.target.value)}
                  />
                  <p className="mt-1 text-[12px] text-grey-500">
                    Required for this dealership (Polaris integration).
                  </p>
                </div>
              )}

              {/* {renderDepartment && (
                <div className="w-full mt-3">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    Department
                  </p>
                  <Select
                    className="w-full"
                    placeholder="Select Department"
                    value={selectedDepartment}
                    onChange={value => setSelectedDepartment(value)}
                    loading={departmentsFetching}
                  >
                    {(departments || []).map(item => (
                      <Select.Option key={item?.id} value={item?.id}>
                        {item?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              )} */}

              {isOpportunityTypeSelectable && (
                <div className="w-full">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    Opportunity Type
                    <span className="requireFieldStar">*</span>
                  </p>
                  <OpportunityTypeCascader
                    opportunityTypes={opportunityTypes}
                    opportunityTypesLoader={opportunityTypesLoader}
                    form={null}
                    canAddEditOpportunity
                    value={opportunityType}
                    onChange={value => {
                      setOpportunityType(value);
                      // Fetch opportunity statuses based on selected type (using root parent ID)
                      if (value) {
                        const locationIds = (
                          sessionStorage?.getItem("currentLocationId") || ""
                        ).includes(",")
                          ? sessionStorage
                              ?.getItem("currentLocationId")
                              ?.split(",")
                              .map(el => +el)
                          : [+sessionStorage?.getItem("currentLocationId")];
                        // Use root parent type ID for fetching statuses (same as leadOpportunityInformationForm)
                        const rootParentTypeId = getRootParentTypeId(+value, opportunityTypes);
                        fetchOpportunityStatusByType({
                          variables: {
                            locationIds,
                            opportunityTypeId: rootParentTypeId,
                          },
                        });
                      }
                    }}
                    style={{ width: "100%" }}
                    allowParentSelection
                  />
                </div>
              )}
              {isSourceSelectable ? (
                <div className="w-full mt-3">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    Opportunity Source
                    <span className="requireFieldStar">*</span>
                  </p>
                  <Cascader
                    options={opportunitySourceOptions}
                    fieldNames={{ label: "name", value: "key", children: "childs" }}
                    className="w-full"
                    expandTrigger="click"
                    loading={leadSourcesLoader}
                    placeholder={
                      leadSourcesLoader
                        ? "Opportunity sources are being fetched..."
                        : "Select Opportunity Source"
                    }
                    value={opportunitySourcePath}
                    onChange={value => {
                      setopportunitySource(value[value.length - 1]);
                      setOpportunitySourcePath(value);
                    }}
                    showSearch={{
                      filter: (inputValue, path) =>
                        path.some(
                          option =>
                            (option.name || "").toLowerCase().indexOf(inputValue.toLowerCase()) > -1
                        ),
                    }}
                    optionRender={option => (
                      <div
                        style={{
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          minWidth: "200px",
                          maxWidth: "400px",
                        }}
                      >
                        {option.name}
                      </div>
                    )}
                  />
                </div>
              ) : (
                <div className="w-full mt-3">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    Opportunity Source
                    <span className="requireFieldStar">*</span>
                  </p>
                  <Input value="Phone Up" disabled />
                </div>
              )}

              {isStatusSelectable && (
                <div className="w-full">
                  <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                    Opportunity Status
                    <span className="requireFieldStar">*</span>
                  </p>
                  <OpportunityStatusCascader
                    expandTrigger="click"
                    canAddEditOpportunity
                    allowParentSelection={false}
                    leadStatusList={leadStatusList || []}
                    opportunityStatusLoader={opportunityStatusLoader}
                    form={null}
                    value={opportunityStatus}
                    onChange={value => {
                      setOpportunityStatus(value);
                    }}
                    style={{ width: "100%" }}
                  />
                </div>
              )}
              <div className="flex flex-col w-full mt-3">
                <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">
                  Vehicle of Interest
                </p>
                {!showWishlistForm ? (
                  <Select
                    style={{ height: "auto" }}
                    showSearch
                    allowClear
                    loading={vdpLoader}
                    placeholder="Select Vehicle of Interest"
                    onChange={value =>
                      setotherData({
                        ...otherData,
                        vehicleOfInterests: [
                          {
                            inputType: "inventory",
                            inventoryId: +value,
                          },
                        ],
                      })
                    }
                    className="w-full"
                    value={
                      (otherData?.vehicleOfInterests &&
                        otherData?.vehicleOfInterests.length > 0 &&
                        otherData?.vehicleOfInterests[0]?.inputType === "inventory" &&
                        +otherData?.vehicleOfInterests[0]?.inventoryId) ||
                      null
                    }
                    filterOption={(input, option) => vehicleFilter(input, option)}
                    dropdownStyle={{
                      minWidth: "500px",
                      height: "auto",
                      maxHeight: "400px",
                      overflowY: "auto",
                    }}
                  >
                    {(vdpData?.getVehicleInventoryV2?.data || []).map((item, index) => (
                      <Select.Option
                        value={+item.id}
                        key={index}
                        label={`${item.year || ""} ${item.make || ""} ${item.model || ""}`}
                        vehicle={item}
                        style={{ padding: "8px" }}
                      >
                        <div className="flex flex-row gap-2 items-center min-w-0">
                          <div className="min-w-[50px] w-[10%] flex-shrink-0">
                            <Image.PreviewGroup
                              items={(item?.vehicleInventoryMedias || []).map(
                                media => media.mediaUrl
                              )}
                            >
                              <Image
                                fallback="https://funnel-webapp-uploads.s3.amazonaws.com/prod/images/generic-car-not-available-image.png"
                                src={(item?.vehicleInventoryMedias || [])[0]?.mediaUrl || ""}
                                height="40px"
                                width="40px"
                                className="rounded-full"
                              />
                            </Image.PreviewGroup>
                          </div>
                          <div className="flex flex-col gap-0.5 flex-1 min-w-0 pr-2">
                            <div className="flex justify-between items-start gap-2">
                              <span className="text-sm font-[600] truncate">
                                {item.year || ""} {item.make || ""} {item.model || ""}
                              </span>
                              <span
                                className="text-[#1677FF] text-sm cursor-pointer hover:underline flex-shrink-0 whitespace-nowrap"
                                onClick={e => {
                                  e.stopPropagation();
                                  setSelectedVehicleForInventoryDetails(item);
                                  setInventoryDetailsDrawerOpen(true);
                                }}
                              >
                                View
                              </span>
                            </div>
                            <span className="text-sm text-grey-700 truncate">
                              <span className="font-semibold">MSRP:</span>{" "}
                              {item?.msrp || item?.sellingPrice
                                ? `${
                                    currencies?.find(
                                      currency => currency.code === item.currencyUnit
                                    )?.symbol
                                  } ${formatPrice(item?.msrp || item?.sellingPrice) || "N/A"}`
                                : "Price not available"}
                            </span>
                            <span className="text-xs font[400] text-[#64748B] truncate">
                              {item.vin}
                            </span>
                            <span className="text-sm text-grey-700 truncate">
                              <span className="font-semibold">Stock No</span>{" "}
                              <span>{item?.stockNumber || "N/A"}</span>
                            </span>
                            <span className="text-sm text-grey-700 truncate">
                              <span className="font-semibold">Model No</span>{" "}
                              <span>{item?.modelNumber || "N/A"}</span>
                            </span>
                            <span className="text-sm text-grey-700 truncate">
                              <span className="font-semibold">Color:</span>{" "}
                              <span>
                                {item?.exteriorColor || "N/A"}
                                <strong>(E)</strong>
                                {", "}
                              </span>
                              <span>
                                {item?.interiorColor || "N/A"}
                                <strong>(I)</strong>
                              </span>
                            </span>
                          </div>
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                ) : (
                  <WishlistVehicleForm
                    index={0}
                    item={wishlistData}
                    years={(function () {
                      const currentYear = new Date().getFullYear();
                      return Array.from({ length: 30 }, (_, index) => currentYear - index);
                    })()}
                    DeleteIcon={null}
                    leadData={{ vehiclesOfInterest: [wishlistData] }}
                    setleadData={data => {
                      const vehicle = data.vehiclesOfInterest[0];
                      setWishlistData(vehicle);
                      setotherData({
                        ...otherData,
                        vehicleOfInterests: [vehicle],
                      });
                    }}
                    InterestDropdown={null}
                  />
                )}
              </div>
              {isFromCRM && (
                <Alert
                  className="mt-2 mb-2"
                  message={
                    <>
                      Starting conversation with customer now. This action will NOT create a new
                      lead or a duplicate entry in the CRM.
                    </>
                  }
                  type="info"
                  showIcon
                />
              )}
            </>
          )}
        </>
      )}
    </>
  );
}

function PhoneInputJsx({ lang, phone, handleSearch }) {
  return (
    <div>
      <p className="mb-2 text-[14px] font-[500] text-grey-700 w-full">Phone number</p>
      <div className="phoneInput">
        <PhoneInput
          defaultCountry={DEFAULT_COUNTRY}
          initialValueFormat="national"
          value={phone}
          placeholder={lang.enterPhone}
          onChange={e => {
            handleSearch(e);
            // debounceFnPhone(e);
          }}
        />
      </div>
    </div>
  );
}
